import 'bootstrap';
import _ from 'underscore';
import $ from 'jquery';
import ko from 'knockout';
import Backbone from 'backbone';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/create/targetPreview.pug';

export default class TargetPreview extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.conditions = _.map(ko.unwrap(this.options.conditions) || [],
      (item) => _.extend({ Operator: '' }, { Operator: ko.unwrap(item.Operator), Operand: ko.unwrap(item.Operand), ArgumentOperand: ko.unwrap(item.ArgumentOperand), DisplayOperand: ko.unwrap(item.DisplayOperand), DisplayOperator: ko.unwrap(item.DisplayOperator)}));
    this.onEscClick = this.onEscClick.bind(this);
  }

  close() {
    if ($('.popover').length > 0) {
      this.target.popover('hide');
    }
  }

  render() {
    this.$el.html(template());
    ko.applyBindings({conditions: this.conditions}, this.el);

    this.target = $(this.options.target);
    this.target.popover({
      html: true,
      trigger: 'manual',
      content: this.$el.html(),
      placement: 'bottom',
    });
    this.target.on('shown.bs.popover', () => {
      $('.popover').css('top', '25px');
      $('.popover').css('left', '0px');
    });
    this.target.popover('show');

    this._bindEvents();
    return this;
  }

  onEscClick(evt) {
    const { keyCode } = evt;

    // escape
    if (keyCode === 27) {
      this.close();
    }
  }

  _bindEvents() {
    const self = this;

    $(document).off('click.body');
    $(document).on('click.body', (e) => {
      if ($(e.target).parents('.preview').length === 0) {
        self.close();
        $(document).off('click.body');
        e.stopPropagation();
      }
    });
    $(document).off('keydown', this.onEscClick).on('keydown', this.onEscClick);
  }
}
